
import { Play } from "lucide-react";
import { Button } from "./ui/button";

const DemoVideo = () => {
  const videoId = "ksfba21jKz4";
  const hasVideo = videoId.length > 0;

  return (
    <section 
      id="demo-video"
      className="py-24 bg-white"
      tabIndex={-1}
      aria-label="Demo video section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mb-4">
            See CSO Agent in Action
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Watch how our AI-powered platform transforms your business strategy with intelligent insights and professional document generation.
          </p>
        </div>
        
        <div className="relative max-w-4xl mx-auto aspect-video rounded-2xl overflow-hidden bg-gray-100 shadow-lg">
          {hasVideo ? (
            <iframe
              src={`https://www.youtube.com/embed/${videoId}`}
              title="Product Demo Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
            />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-cso-50 to-cso-100">
              <div className="text-center">
                <Button
                  size="lg"
                  className="bg-cso-600 hover:bg-cso-700 text-white rounded-full focus:ring-2 focus:ring-cso-600 focus:ring-offset-2"
                  aria-label="Demo video coming soon"
                >
                  <Play className="mr-2 h-5 w-5" />
                  Watch Now
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default DemoVideo;
